import React from 'react'

import { Link } from 'gatsby'
import htmr from 'htmr'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

import { User } from '../../redux/actions'
import { displaySearchModalSelector } from '../../redux/selectors'
import { colors, space } from '../../style/design-system'

const Result = ({ className, result }) => {
  const dispatch = useDispatch()
  const displaySearchModal = useSelector(displaySearchModalSelector)

  let title = result?.title?.snippet || result?.title?.raw || 'Untitled'
  title = title.replace('| Ultimate Medical Academy', '')
    .replace('| UMA', '')

  const body = result?.body?.snippet

  return (
    <Link
      onClick={() => dispatch(User.showSearchModal(!displaySearchModal))}
      className={`${className} px-7 py-8`}
      to={result.url.raw.replace('https://www.ultimatemedical.edu', '')}>
      <span className="heading h3 blue mb-2 mt-0">{htmr(title)}</span>
      {body && <span className="body">{htmr(body)}</span>}
    </Link>
  )
}

export default styled(Result)`
  border-bottom: 2px solid ${colors.dev.gray.h()};
  color: ${colors.dev.gray.b()};
  display: block;
  font-size: 0.9rem;
  text-decoration: none;

  &:hover {
    color: ${colors.dev.gray.b()};
    text-decoration: none;

    .heading {
      border-bottom: 1px solid ${colors.dev.blue.d()};
    }
  }

  .heading {
    padding-bottom: 0.25rem;
    border-bottom: 1px solid transparent;
    transition: 0.2s ease-in-out;
    display: inline-block;

    em {
      padding: 0 ${space.b} ${space.b} ${space.b};
    }
  }

  .body {
    display: block;
  }

  em {
    background-color: ${colors.dev.blue.i()};
    border-radius: 4px;
    color: ${colors.dev.blue.a()};
    display: inline-block;
    font-style: normal;
    padding: 0 ${space.b};
  }
`
